import { BaseAction, RootAction } from "../RootAction";
import { LoginUrl, LogoutUrl } from "../../../Constants/ConstantsValue";

export const login = (formData, callBack) => dispatch => {
    let action = new BaseAction({
        type: RootAction.Access.Login,
        method: "POST",
        params: formData,
        endPoint: LoginUrl,
        //autoRedirect: false
    });

    if (callBack) {
        dispatch(action.ToPlanObject())
            .then((res) => {
                callBack(res);
            });
    }
}

export const loginFA = (url) => {
    let action = new BaseAction({
        type: RootAction.Access.LoginFA,
        method: "POST",
        params: null,
        endPoint: url
    });

    return action.ToPlanObject();
}

export const logout = (params, callBack) => dispatch => {
    let action = new BaseAction({
        type: RootAction.Access.Logout,
        method: "POST",
        params: params,
        endPoint: LogoutUrl
    });

    if (callBack) {
        dispatch(action.ToPlanObject())
            .then((res) => {
                callBack(res);
            });
    }
    else {
        return dispatch(action.ToPlanObject());
    }
}

export const logoutWI = (params, isLogoutAll, callBack) => dispatch => {
    let action = new BaseAction({
        type: RootAction.Access.Logout,
        method: "POST",
        params: params,
        endPoint: `${LogoutUrl}?isLogoutAll=${isLogoutAll}`
    });

    if (callBack) {
        dispatch(action.ToPlanObject())
            .then((res) => {
                callBack(res);
            });
    }
    else {
        return dispatch(action.ToPlanObject());
    }
}
